module.exports = __webpack_public_path__ + "img/model_image-1.05c568de.png";